import { useContext } from "react";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box } from "@mui/material";
import { SortArrow } from "../../../Features/NewInvoiceBook/InvoiceBookPages/InvoiceList";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const TableHeader = ({isAscendingType, isAscending, handleSort, disabled = false}) => {
  const [I18n] = useContext(LanguageContext);
  return (
    <Box className={`invoiceListTableHeader accountTableHeaderMain ${styles.mainTableHeaderWrapper}`}>
      <Box
        onClick={disabled ? undefined : () => { triggerLogEvent(analytics, "bo_category_sort", { column: "date" }); handleSort("date") }}
        className={`invListTableHeaderCol fiveColumn textLeft sidebarOption ${disabled ? "" : "cursorPointer"}`}
      >
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.date}
        >
          {I18n.date}{" "}
          <SortArrow id="uncategorized_date_sort" isAscending={isAscending} disabled={disabled} />
        </ParagraphText>
      </Box>
      <Box
        onClick={disabled ? undefined : () => { triggerLogEvent(analytics, "bo_category_sort", { column: "type" }); handleSort("type") }}
        className={`invListTableHeaderCol fiveColumn textLeft ${disabled ? "" : "cursorPointer"}`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.type}
        >
          {I18n.type}{" "}
          <SortArrow id="uncategorized_type_sort" isAscending={isAscendingType} disabled={disabled} />
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fiveColumn textLeft`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.description}
        >
          {I18n.description}{" "}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fiveColumn textLeft`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor textLeft"}
          key={I18n.status}
        >
          {I18n.status}{" "}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fiveColumn textRight`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor textRight"}
          key={I18n.amount}
        >
          {I18n.amount}{" "}
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default TableHeader;
